import MemberRequiredActionsFlow from "../../components/MemberRequiredActionsFlow";

export default function MemberRequiredActionsPage() {
  return <MemberRequiredActionsFlow />;
}
